import { Grid, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { trickleDownPasses } from "./coverageUtils";

interface Props {
  labellableFraction: number;
  verifiedFraction: number;
  labelledByPasses: Record<string, number>;
}

export const CoverageSummary = ({
  labellableFraction,
  verifiedFraction,
  labelledByPasses,
}: Props) => {
  const { t } = useTenantTranslation();
  const trickledPasses = trickleDownPasses(labelledByPasses);

  return (
    <Grid container spacing={1}>
      <Grid size={6}>
        <Typography variant="caption" color="text.secondary">
          {t("labellable")}
        </Typography>
        <Typography variant="body2" fontWeight="bold">
          {labellableFraction.toFixed(1)}%
        </Typography>
      </Grid>
      <Grid size={6}>
        <Typography variant="caption" color="text.secondary">
          {t("verified")}
        </Typography>
        <Typography
          variant="body2"
          fontWeight="bold"
          color={
            verifiedFraction > 0.9
              ? "success.main"
              : verifiedFraction > 0.5
                ? "warning.main"
                : "error.main"
          }
        >
          {(verifiedFraction * 100).toFixed(1)}%
        </Typography>
      </Grid>
      <Grid size={6}>
        <Typography variant="caption" color="text.secondary">
          {t("onePassPlus")}
        </Typography>
        <Typography variant="body2">
          {((trickledPasses[1] ?? 0) * 100).toFixed(1)}%
        </Typography>
      </Grid>
      <Grid size={6}>
        <Typography variant="caption" color="text.secondary">
          {t("twoPlusPassPlus")}
        </Typography>
        <Typography variant="body2">
          {((trickledPasses[2] ?? 0) * 100).toFixed(1)}%
        </Typography>
      </Grid>
    </Grid>
  );
};
